var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { noView } from "aurelia-templating";
import { customAttribute } from "aurelia-templating";
import { bindable } from "aurelia-templating";
var InnerhtmlReadMoreLessAttribute = /** @class */ (function () {
    function InnerhtmlReadMoreLessAttribute(element) {
        this.element = element;
        this.charsPerWidth = { 400: 110 };
        this.showMoreText = "Show more";
        this.showLessText = "Show less";
        this.ellipsesText = "...";
    }
    InnerhtmlReadMoreLessAttribute.prototype.htmlChanged = function (newValue, oldValue) {
        var content = this.html;
        var closest = this.getClosest(this.element.clientWidth, Object.keys(this.charsPerWidth).map(function (x) { return Number(x); }));
        var showChar = this.charsPerWidth[closest];
        if (content.length > showChar) {
            var self_1 = this;
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
            var html = c + "<span class='moreellipses'>" + this.ellipsesText + "&nbsp;</span><span class='morecontent'><span style='display:none'>" + h + "</span>&nbsp;&nbsp;<a href='' class='morelink'>" + this.showMoreText + "</a></span>";
            $(this.element).html(html);
            $(this.element).find(".morelink").click(function () {
                if ($(this).hasClass("less")) {
                    $(this).removeClass("less");
                    $(this).html(self_1.showMoreText);
                }
                else {
                    $(this).addClass("less");
                    $(this).html(self_1.showLessText);
                }
                $(this).parent().prev().toggle();
                $(this).prev().toggle();
                return false;
            });
        }
        else {
            $(this.element).html(content);
        }
    };
    InnerhtmlReadMoreLessAttribute.prototype.getClosest = function (num, arr) {
        var mid;
        var lo = 0;
        var hi = arr.length - 1;
        while (hi - lo > 1) {
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] < num) {
                lo = mid;
            }
            else {
                hi = mid;
            }
        }
        if (num - arr[lo] <= arr[hi] - num) {
            return arr[lo];
        }
        return arr[hi];
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], InnerhtmlReadMoreLessAttribute.prototype, "html", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], InnerhtmlReadMoreLessAttribute.prototype, "charsPerWidth", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], InnerhtmlReadMoreLessAttribute.prototype, "showMoreText", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], InnerhtmlReadMoreLessAttribute.prototype, "showLessText", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], InnerhtmlReadMoreLessAttribute.prototype, "ellipsesText", void 0);
    InnerhtmlReadMoreLessAttribute = __decorate([
        customAttribute("innerhtml-read-more-less"),
        noView,
        autoinject,
        __metadata("design:paramtypes", [Element])
    ], InnerhtmlReadMoreLessAttribute);
    return InnerhtmlReadMoreLessAttribute;
}());
export { InnerhtmlReadMoreLessAttribute };
